<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    caseTypes: (caseTypes$ | async) ?? [],
    selectedCaseType: (selectedCaseType$ | async),
    disabled: (disabled$ | async) || true
  }"
></ng-container>

<ng-template
  #template
  let-caseTypes="caseTypes"
  let-selectedCaseType="selectedCaseType"
  let-disabled="disabled"
>
  <mat-form-field flex="100">
    <mat-label [innerText]="label"></mat-label>
    <mat-select
      #caseTypeSelect
      [attr.disabled]="disabled"
      [formControl]="formControl"
      (selectionChange)="selectionChanged($event)"
    >
      <mat-option [value]="null">{{ noneSelectedText }}</mat-option>
      <mat-option *ngFor="let casetype of caseTypes" [value]="casetype.caseTypeId">
        {{ casetype.displayName }}
      </mat-option>
    </mat-select>
    <mat-hint *ngIf="selectedCaseType"> Description: {{ selectedCaseType?.description }} </mat-hint>
  </mat-form-field>
</ng-template>
